"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findTopK = void 0;
const findTopK = (k, data, compareBy) => {
    let currMax = data[0][compareBy];
    const top = [];
    top.push([]);
    for (let i = 0; i < data.length; i++) {
        if (top.length > k) {
            top.pop();
            break;
        }
        const item = data[i];
        if (item[compareBy] === currMax) {
            top[top.length - 1].push(item);
        }
        else {
            currMax = item[compareBy];
            top.push([]);
            i--;
        }
    }
    return top;
};
exports.findTopK = findTopK;
//# sourceMappingURL=findTopK.js.map